const messages = {
  en: require('~/translations/en.json'),
  lt: require('~/translations/lt.json'),
  pl: require('~/translations/pl.json'),
};

export default (_, locale) => {
  const lang = locale.split('-')[0];
  const translations = messages[lang] || {};
  // const loadedTranslations = await api.getTranslations(context, {
  //   language: lang,
  // });
  const loadedTranslations = {};
  const fullTrans = { ...translations, ...loadedTranslations };
  return fullTrans;
};
